<template>
    <v-main class="px-10" style="height: 100%;">

        <h1 style="line-height: 100px;">Company Academy</h1>
        <div v-if="categories.length > 0">
            <moduleList :modules="categories" />
        </div>
        <div v-else style="text-align:center; margin: auto; width: 50%; padding: 15% 0;">
            <h2>Nothing here yet!</h2>
        </div>
    </v-main>

</template>

<script>
    import axios from "axios";
    import moduleList from './moduleList.vue';

    export default {
        components: { moduleList },
        data() {
            return {
                categories: null,
            }
        },

        mounted () {
            this.getTrainingModules();
        },

        methods: {
            getTrainingModules () {
                axios.get("/system/vTraining/module/list")
                .then(response => {
                    this.categories = response.data;
                })
                .catch(() => {});
            }
        }
    }
</script>

<style>

</style>